import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { db } from '../../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

// Полный доступ: роль не "newbie" ИЛИ участие хотя бы в одной группе
const useFullAccess = () => {
  const user = useSelector((s) => s.auth.user);
  const [member, setMember] = useState(false);

  useEffect(() => {
    if (!user?.uid) { setMember(false); return; }
    if ((user.role || 'user') !== 'newbie') { setMember(true); return; }
    const q = query(collection(db, 'groups'), where('members', 'array-contains', user.uid));
    const unsubscribe = onSnapshot(q, (snap) => setMember(!snap.empty), () => setMember(false));
    return () => unsubscribe();
  }, [user?.uid, user?.role]);

  return member;
};

export default useFullAccess;